import type { VoiceCatalog } from './voice.ts';

/**
 * The voice assistant's lines, Turkish (W3-01). The disclosure and the outbound opening follow
 * the spec's Turkish (F6 step 2, §9.4 "Opening (TR)"); the rest written for W3-01. Formal "siz",
 * no exclamation marks (§9.7); for the native-speaker read (§19 Q63).
 */
export const voiceTr: VoiceCatalog = {
  recording_notice: 'Günlük raporunuz için bu görüşme kaydediliyor.',
  opening_inbound:
    'TalkOlog, merhaba {first}. {recording_notice} {site} için bugünün raporunu dinliyorum.',
  opening_inbound_pick_site: 'TalkOlog, merhaba {first}. {recording_notice}',
  opening_outbound:
    'Merhaba {first}, ben {company} için TalkOlog asistanı. {recording_notice} {site} için bugünün raporunu alabilir miyim?',
  opening_talk_now:
    'TalkOlog, merhaba {first}. {recording_notice} {site} için bugünün raporunu dinliyorum.',
  go_ahead:
    'Buyurun: bugün ne yapıldı, sahada kimler vardı, hava, teslimatlar ve eklemek istedikleriniz.',
  pick_site: 'Bu rapor hangi şantiye için: {sites}?',
  pick_site_by_name: 'Şantiyenin adını söyleyin.',
  or: 'ya da',
  backchannel: 'Hı hı, devam edin.',
  filler: 'Anladım, bir saniye.',
  silence_prompt: 'Hâlâ hatta mısınız?',
  silence_goodbye:
    'Söylediklerinizi kaydettim, raporu tamamlamanız için size bir link göndereceğim. İyi günler.',
  time_warning: 'Görüşmenin bitmesine yaklaşık iki dakika kaldı.',
  fallback: 'Basit yoldan yapalım: sinyal sesinden sonra her şeyi anlatın, bitince kapatın.',
  readback_crew:
    'Elimdeki bilgiler: {companies} firmadan sahada {workers} kişi, toplam {hours} saat.',
  readback_crew_one_company:
    'Elimdeki bilgiler: bir firmadan sahada {workers} kişi, toplam {hours} saat.',
  readback_weather: 'Hava nedeniyle {hours} saat çalışılamadı.',
  readback_change: 'Değişti: {change}.',
  confirm_ask: 'Kaydedeyim mi?',
  confirm_repeat: 'Kaydedeyim mi? Evet ya da hayır deyin.',
  weather_day_crew_ask:
    'Saat {time} itibarıyla hava nedeniyle iş durdu, ekip eve gönderildi. Bu sabah sahada kaç kişi vardı?',
  weather_photo_link: 'Hava koşullarının bir fotoğrafı kaydı güçlendirir. Size bir link gönderdim.',
  consent_ask:
    "Bu görüşmeleri kaydetmem ve size rapor linklerini WhatsApp'tan göndermem uygun mu? Evet ya da hayır deyin.",
  preference_ask: 'Her iş günü arama mı istersiniz, yoksa linkinizi mesajla mı göndereyim?',
  consent_declined: 'Anlaşıldı. Bu görüşmeden hiçbir şey saklanmayacak. İyi günler.',
  consent_declined_link:
    'Anlaşıldı. Bu görüşmeden hiçbir şey saklanmayacak. Raporu web üzerinden verebilmeniz için linkinizi mesajla göndereceğim. İyi günler.',
  unknown_greeting: 'Merhaba, ben TalkOlog asistanı.',
  unknown_caller:
    "Bu numara henüz TalkOlog'da kayıtlı değil. Adınızı, firmanızı ve şantiyeyi söyleyin, ofise ileteyim.",
  unknown_goodbye: 'Teşekkürler, ofise ileteceğim. İyi günler.',
  goodbye_filed: 'Kaydedildi. PDF ve fotoğraf eklemeniz için bir link gönderdim. İyi akşamlar.',
  goodbye_draft_saved:
    'Taslağınızı kaydettim, tamamlamanız için bir link göndereceğim. İyi günler.',
  goodbye_no_work: '{site} için bugün çalışma yok olarak kaydettim. İyi akşamlar.',
  goodbye_weather_day:
    '{site} için bugünü hava nedeniyle kayıp gün olarak kaydettim. İyi akşamlar.',
  goodbye_edit_applied: 'Tamam. Güncellenen rapor ofise gidiyor. İyi günler.',
  goodbye_callback_requested: 'Tamam, sizi saat {time} gibi arayacağım. İyi günler.',
  goodbye_fallback_recording:
    'Teşekkürler. Taslağı kontrol etmeniz için bir link göndereceğim. İyi günler.',
  goodbye_abandoned: 'İyi günler.',
  pref_call_ok: 'Tamam, günlük raporunuz artık telefonla.',
  pref_text_ok: 'Tamam, günlük raporunuz artık mesajla gelen linkle.',
  load_report_summary: '{day} raporu, {report_no}: sahada {workers} kişi, {hours} saat.',
  load_report_found: '{day} raporunu buldum, {report_no}.',
  still_working: 'Hâlâ üzerinde çalışıyorum, bir dakika.',
  answer_crew: '{company}: {workers} kişi, kişi başı {hours_each} saat — toplam {hours} saat.',
  answer_crew_workers: '{company}: {workers} kişi.',
  answer_weather: 'Not aldım: hava nedeniyle {hours} saat kayıp.',
  answer_no_stoppage: 'Not aldım: hava nedeniyle duruş yok.',
  answer_company_added: 'Not aldım: {company}, ofisin onaylayacağı yeni bir taşeron.',
  answer_company_mapped: 'Not aldım: {company}.',
  answer_noted: 'Not aldım.',
  answer_again: 'Kusura bakmayın, anlayamadım.',
  answer_skipped: 'Bunu anlayamadım, ofisin kontrol etmesi için bırakıyorum.',
  readback_work: 'Yapılanlar: {items}.',
  readback_work_complete: '{item} tamamlandı',
  readback_work_percent: '{item} yaklaşık yüzde {percent}',
  readback_work_count: 'Not edilen iş: {count}.',
  readback_deliveries: 'Teslimatlar: {items}.',
  readback_delivery_quantity: '{quantity} {item}',
  readback_delivery_from: '{supplier} firmasından {item}',
  readback_deliveries_count: 'Not edilen teslimat: {count}.',
  readback_toolbox: 'İş güvenliği konuşması yapıldı.',
  readback_no_incidents: 'Kaza ya da olay yok.',
  readback_incident_one: 'Bir olay bildirildi.',
  readback_incidents: '{count} olay bildirildi.',
  correction_crew_removed: '{company} rapordan çıkarıldı.',
  correction_unclear: 'Özür dilerim, bu değişikliği yapamadım. Neyi değiştireyim?',
  correction_nothing: 'Raporda zaten böyle.',
  day_off_confirm_no_work: '{site} için bugün çalışma yok mu? Evet ya da hayır deyin.',
  day_off_confirm_weather:
    '{site} için hava nedeniyle kayıp gün: iş saat {time} itibarıyla durdu, {hours} saat kayıp. Kaydedeyim mi?',
  day_off_confirm_weather_crew:
    '{site} için hava nedeniyle kayıp gün: iş saat {time} itibarıyla durdu, öncesinde sahada {workers} kişi vardı, {hours} saat kayıp. Kaydedeyim mi?',
  day_off_confirm_never:
    '{site} için hava nedeniyle kayıp gün: ekip hiç başlamadı, {hours} saat kayıp. Kaydedeyim mi?',
  day_off_confirm_never_crew:
    '{site} için hava nedeniyle kayıp gün: {workers} kişilik ekip hiç başlamadı, {hours} saat kayıp. Kaydedeyim mi?',
  day_off_confirm_repeat: 'Kaydedeyim mi? Evet ya da hayır deyin.',
  day_off_logged_no_work: 'Kaydedildi: {site} için bugün çalışma yok.',
  day_off_logged_weather: 'Kaydedildi: {site} için hava nedeniyle kayıp gün.',
  day_off_in_progress:
    'Bugünün raporu zaten başladı, bunu raporda söyleyin: işi ne durdurdu ve ne kadar sürdü.',
  day_off_filed: '{site} için bugünün raporu zaten kaydedildi.',
  day_off_site_paused: "{site} TalkOlog'da duraklatılmış. Ofisten yeniden başlatmasını isteyin.",
  callback_unavailable:
    'Sizi henüz geri arayamıyorum. Hazır olduğunuzda tekrar arayın ya da linkinizi kullanın.',
  callback_outside_window: 'En geç saat {time} gibi arayabilirim. Raporu şimdi yapalım mı?',
  callback_limit: 'Günde yalnızca bir kez geri arayabilirim. Raporu şimdi yapalım mı?',
  pref_not_today_ok: 'Tamam, bugün sizi bir daha aramayacağım.',
  edit_ask: 'Neyi değiştireyim?',
  edit_save_ask: 'Kaydedeyim mi?',
  edit_save_repeat: 'Kaydedeyim mi? Evet ya da hayır deyin.',
  edit_saved: 'Kaydedildi. Sürüm {version} ofise gidiyor.',
  edit_changed_meanwhile: 'Biz konuşurken rapor değişti. Değişikliği tekrar söyleyin.',
  edit_locked: 'Bu rapor kilitli. Değiştirmesi için ofise başvurun.',
  edit_not_found: 'O gün için kaydedilmiş bir rapor bulamadım.',
  edit_ambiguous: 'O gün iki rapor var. Hangi şantiye?',
  edit_pending: 'Hâlâ son değişiklik üzerinde çalışıyorum, bir saniye.',
  consent_given: 'Teşekkür ederim.',
  consent_repeat:
    "Kusura bakmayın, bu görüşmeleri kaydetmem ve size rapor linklerini WhatsApp'tan göndermem uygun mu? Evet ya da hayır deyin.",
  tool_error: 'Kusura bakmayın, bu işlem şu an olmadı. Tekrar deneyelim.',
  test_call_greeting: 'Merhaba, ben TalkOlog asistanı. Bu görüşme kaydedilmiyor.',
  test_call_line:
    'Bu, {company} için TalkOlog deneme aramasıdır. Telefonunuz TalkOlog aramalarını almaya hazır.',
  test_call_goodbye: 'Deneme bu kadar. İyi günler.',
};
